import { render, staticRenderFns } from "./UnitGroupPanel.vue?vue&type=template&id=5267b5e9&scoped=true&"
import script from "./UnitGroupPanel.vue?vue&type=script&lang=js&"
export * from "./UnitGroupPanel.vue?vue&type=script&lang=js&"
import style0 from "./UnitGroupPanel.vue?vue&type=style&index=0&id=5267b5e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5267b5e9",
  null
  
)

export default component.exports